// extracted by mini-css-extract-plugin
module.exports = {"marketing":"MarketingSidebar_marketing__g9STu","marketingInfoBox":"MarketingSidebar_marketingInfoBox__KMsZ-"};